// utils/jsonGenerator.js

export const generateEmailJSON = (blocks, subject = '') => {
  const emailData = {
    version: '1.0',
    metadata: {
      subject: subject,
      createdAt: new Date().toISOString(),
      lastModified: new Date().toISOString(),
      template: true
    },
    structure: {
      blocks: blocks.map(block => ({
        id: block.id,
        type: block.type,
        properties: { ...block.properties },
        children: block.children ? block.children.map(child => ({
          id: child.id,
          type: child.type,
          properties: { ...child.properties }
        })) : undefined
      }))
    },
    settings: {
      width: '600px',
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif'
    }
  };

  return emailData;
};

export const loadEmailFromJSON = (jsonData) => {
  try {
    const data = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
    
    return {
      blocks: data.structure?.blocks || [],
      subject: data.metadata?.subject || '',
      settings: data.settings || {}
    };
  } catch (error) {
    console.error('Error loading email from JSON:', error);
    return {
      blocks: [],
      subject: '',
      settings: {}
    };
  }
};

export const validateEmailJSON = (jsonData) => {
  try {
    const data = typeof jsonData === 'string' ? JSON.parse(jsonData) : jsonData;
    
    const errors = [];
    
    if (!data.version) {
      errors.push('Missing version field');
    }
    
    if (!data.metadata) {
      errors.push('Missing metadata field');
    }
    
    if (!data.structure || !Array.isArray(data.structure.blocks)) {
      errors.push('Missing or invalid structure.blocks field');
    }
    
    // Validate block structure
    if (data.structure && data.structure.blocks) {
      data.structure.blocks.forEach((block, index) => {
        if (!block.id) {
          errors.push(`Block at index ${index} missing id`);
        }
        if (!block.type) {
          errors.push(`Block at index ${index} missing type`);
        }
        if (!block.properties) {
          errors.push(`Block at index ${index} missing properties`);
        }
      });
    }
    
    return {
      isValid: errors.length === 0,
      errors: errors
    };
  } catch (error) {
    return {
      isValid: false,
      errors: [`Invalid JSON format: ${error.message}`]
    };
  }
};